export class User {
  constructor(
    public hash: string,
    public firstname: string,
    public lastname: string,
    public email: string,
    public birthDate: number
  ) { }

  get fullname(): string {
    return `${this.firstname} ${this.lastname}`;
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/models/user.ts